import * as React from 'react';

import { DialogLogin} from './DialogLogin';
import { DialogNewPassword } from './DialogNewPassword';
import { PasswordChangedDialog } from '../passwordchangeddialog/PasswordChangedDialog';


import "./logindialog.css";

export const  LoginDialog = () => {

  return (

    <div>
        <DialogLogin />
     
        <DialogNewPassword />
        <PasswordChangedDialog />
        

    </div>
    
  );
}